import { createContext, useContext } from "react";

export const ExpressionExecutionContext = createContext(false);

export const useDisableExpressionExecution = () =>
  useContext(ExpressionExecutionContext);
